import { matRaisedButtonCSS } from './composerSaveButton';

/* Custom Modul for the Properties Panel */
export function ComposerSelectLogo(options: {
    id: string;
    imageDataSrc: string;
}) {
    const label = 'Toolchain Logo';
    const buttonLabel = 'Logo auswählen';

    /* Custom Event that gets triggered when the Button is clicked - Handled by ComposerChangeHandler */
    const customEvent =
        "{const customEvent = document.createEvent('HTMLEvents');" +
        "customEvent.initEvent('chooseIcon', true, true);" +
        "customEvent.eventName = 'chooseIcon';" +
        'event.target.dispatchEvent(customEvent);}';

    const imageHTML =
        options.imageDataSrc !== ''
            ? '<img src="' +
              options.imageDataSrc +
              '" style="width: 60%; height: 40%;">'
            : '';

    return {
        id: options.id,
        html:
            '<div><label data-value="label" ' +
            'style="margin-bottom: 0"></label></div><div>' +
            imageHTML +
            '<button class="btn_green" style="' +
            matRaisedButtonCSS +
            '" onclick="' +
            customEvent +
            '">' +
            buttonLabel +
            '</button>' +
            '</div>',
        get: function (element, node) {
            return {
                label: label
            };
        }
    };
}
